import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ScrollProgress, MouseGlow, Grain } from "@/components/effects";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { Showreel } from "@/components/Showreel";
import { ShortForm } from "@/components/ShortForm";
import { Results } from "@/components/Results";
import { Testimonials } from "@/components/Testimonials";
import { Services } from "@/components/Services";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { InstagramStrip } from "@/components/InstagramStrip";
import { Footer } from "@/components/Footer";

const Home = () => (
  <>
    <Hero />
    <TrustBar />
    <Showreel />
    <ShortForm />
    <Results />
    <Testimonials />
    <Services />
    <Faq />
    <Contact />
  </>
);

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Grain />
        <ScrollProgress />
        <MouseGlow />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <InstagramStrip />
        <Footer />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
